import React, { Component} from 'react';

import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { observer, inject } from 'mobx-react';


const errorStyle = {
  fontSize: 13,
  color: 'red'
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: ''
    };
  }

  handleClear = () => {
    this.setState({email: '', password: ''})
  };

  handleSubmit = () => {
    this.props.Auth.login(this.state.email, this.state.password)
      .then((res) => {
        this.props.Auth.setUser(res.data)

        this.props.Auth.getProfile().then(() => {
          if (['admin', 'superadmin', 'manager'].includes(this.props.Auth.role)) {
            this.props.Auth.getOrgName().then(() => this.props.history.push('/children'))
          } else {
            this.props.history.push('/login');
          }
        });
      })
      .catch((err) => {
        switch(err.response.status) {
          case 400:
            this.setState({error: 'Fill Email and/or Password fields'});
            break;
          case 401:
            this.setState({error: 'Wrong Email and/or Password fields'});
            break;
          default:
            this.setState({error: err.message});
        }
      });
  };

  keyPressed = (event) => {
    if (event.key === "Enter") {
      this.handleSubmit();
    }
  };

  render() {
    return (
      <Paper elevation={1} className="loginPaper">
        <span style={{color: '#1565c0', fontSize: 20}}>Login</span>
        <br/>
        <br/>
        <span style={errorStyle}>{this.state.error}</span>
        <br/>
        <TextField
          id="email"
          label="Email"
          fullWidth={true}
          value={this.state.email}
          onChange={(e) => this.setState({email: e.target.value})}
          margin={"normal"}
          autoComplete="email"
          slotProps={{ inputLabel: { shrink: true } }}
        />
        <br />
        <TextField
          id="password"
          label="Password"
          fullWidth={true}
          type="password"
          value={this.state.password}
          onChange={(e) => this.setState({password: e.target.value})}
          onKeyPress={this.keyPressed}
          margin={"normal"}
          autoComplete="current-password"
          slotProps={{ inputLabel: { shrink: true } }}
        />
        <br />
        <br />
        <Button
          variant="contained"
          color="primary"
          style={{marginRight: 10}}
          onClick={this.handleClear}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{marginLeft: 10}}
          onClick={this.handleSubmit}
        >
          Login
        </Button>
      </Paper>
    )
  }
}

export default inject("Auth")(observer(Login))
